import * as Yup from 'yup';

Yup.addMethod(Yup.string, 'sequence', function (funcList) {
    return this.test(async (value, context) => {
        try {
            for (const func of funcList) {
                await func(context).validate(value);
            }
        } catch (e) {
            const message = (e as Yup.ValidationError).message;

            return context.createError({ message });
        }
        return true;
    });
});
